const unusableSource = (source) => !source || ["[object Object]", "undefined", "null"].includes(source);

export const serializeAdSource = (source) => {
  if (source == null) return "";
  if (typeof source === "string") return source;
  try {
    const serialized = JSON.stringify(source);
    return typeof serialized === "string" ? serialized : "";
  } catch (error) {
    return "";
  }
};

export const storeNativeAttribution = (info, storage = localStorage) => {
  if (!info || !info.name || !info.id) return info;
  const provider = storage.getItem("attribution");
  const source = serializeAdSource(info.source);
  if (!provider) {
    storage.setItem("attribution", info.name);
    storage.setItem("attribution_id", info.id);
    storage.setItem("ad_source", unusableSource(source) ? "" : source);
  } else if (provider === String(info.name) && storage.getItem("attribution_id") === String(info.id) &&
      unusableSource(storage.getItem("ad_source")) && !unusableSource(source)) {
    // Repair a damaged source only when the provider and device ID still match.
    storage.setItem("ad_source", source);
  }
  return info;
};

export const storeNativeAdSource = (source, storage = localStorage) => {
  if (!storage.getItem("ad_source")) {
    const serialized = serializeAdSource(source);
    if (!unusableSource(serialized)) storage.setItem("ad_source", serialized);
  }
  return source;
};

export const getRegistrationAttribution = (storage = localStorage) => ({
  attribution: storage.getItem("attribution") || "",
  attribution_id: storage.getItem("attribution_id") || "",
  ad_source: storage.getItem("ad_source") || "",
});
